import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-card-selection-number-actions',
  templateUrl: './card-selection-number-actions.component.html',
  styleUrls: ['./card-selection-number-actions.component.less'],
})
export class CardSelectionNumberActionsComponent implements OnInit {
  @Input() title: string;
  @Input() number: number;
  @Input() actionsText: string[];
  @Input() icon: string;
  @Input() colorType: string;
  @Input() tooltipText: string;

  @Output() onActionsClicked: EventEmitter<number> = new EventEmitter<number>();

  constructor() {}

  ngOnInit(): void {}

  actionsClicked(index) {
    this.onActionsClicked.emit(index);
  }
}
